import React, { Fragment } from 'react'

export const netLandArea = undefined

export const unitCountPrivate = undefined
export const unitSizePrivate = undefined
export const salesValuePrivate = undefined

export const unitCountAffordable = undefined
export const unitSizeAffordable = undefined
export const salesValueAffordable = undefined

export const baseBuildCost = `
  This covers the construction of the dwelling only, but not works to the plot
  or other wider site works.  Currently for typical estate housing within a
  larger scheme this would be c.£90 sq ft. For smaller schemes the cost will be
  higher, and for apartments in excess of £100 sq ft.
`

export const developmentContingency = `
  This is a percentage of the base build cost and is typically 3-5% and covers
  delays, cost over run or issues arising that had not been planned.
`
export const constructionAbnormals = `
  This is the sum of ‘non-standard’ site works and could include the cost of site
  clean up, demolition, enabling highways works, utilities upgrades, and
  foundation enhancement. S106 costs could be included within this item.
`
export const externals = `
  Covers the cost of delivering site roads, landscaping, parking, layout of
  ‘Public Open Space’ and completion of plot areas. Without an accurate ‘Bill of
  Costs’ for this element, this is expressed as percentage, typically 15% - 20%
  of the ‘Base Build Cost’.
`
export const professionalFees = `
  Accounts for all the fees paid to professionals during the conception and
  delivery of the scheme. This covers input by Architects, Quantity Surveyors,
  Civil & Structural Engineers, and Project Managers. Expressed as a percentage
  of the ‘Total Build Cost’, this is typically 11% of the ‘Total Build Cost’,
  but could be increased by 1-2% points if a scheme was complex, had retained
  historical buildings or in a city centre location.
`
export const salesAndMarketing = `
  Covers the cost of marketing the wider scheme, and estate agents fees for
  selling the individual houses.
`
export const legalFeesPerUnit = undefined
export const finance = `
  Cost of the development finance for delivering the scheme. The percentage
  reflects prevailing economic conditions.
`

export const profit = `
  For a housing scheme the target development profit is based upon the total
  sales revenue (Gross Development Value) and is the reward for the developer in
  building out the scheme. Currently 20% profit on sales is applicable, although
  if this was a purely apartment based scheme, profit would be based on the
  ‘Total Build Cost’.
`
export const legalSiteAcquisitionCost = `
  Legal cost for acquiring the land. There is no set fee level for such. In
  terms of assumptions schemes of up to 30 units £20,000, schemes of 30-80 units
  £30,000 and schemes in excess of 80 units £40,000.
`
export const planning = `
  This cost relates to the preparation and submission of the planning
  application. There is no fixed cost for such so the following assumptions are
  for schemes of up to 30 units £40,000, schemes of 30-80 units £60,000 and
  schemes in excess of 80 units £80,000.
`
export const surveys = `
  This cost includes topographical surveys, ground investigations, asbestos
  surveys, ecology surveys, drainage, highways etc. In terms of assumptions
  schemes of up to 30 units £30,000, schemes of 30-80 units £40,000 and schemes
  in excess of 80 units £60,000.
`

export const stampDuty = (
  <Fragment>
    Incorporating a Stamp Duty calculation within such a basic appraisal adds
    unnecessary complexity. Consequently parties need to be aware that this is
    additional cost and the cost can be obtained by utilising the calculator
    within
    {' '}
    <a href='https://www.gov.uk/stamp-duty-land-tax' target='_blank' rel='noopener noreferrer'>
      www.gov.uk/stamp-duty-land-tax
    </a>.
    Please note that for housing sites the basis should be commercial property
    not residential.
  </Fragment>
)

export const toolDisclaimer = `
  Outputs related to this ‘Residual Development Appraisal Tool’ are indicative
  only and should not be relied upon for valuation purposes. Outputs do not
  represent valuations under the RICS ‘Red Book’.
`

export const landValue = `
  For the assumptions of this ‘basic appraisal’, this is the residue once the
  total costs (including profit and acquisition costs) are subtracted from the
  Gross Development Value (GDV).
`
